import { render, staticRenderFns } from "./ResetPasswordChangeForm.vue?vue&type=template&id=454ae6be&"
import script from "./ResetPasswordChangeForm.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordChangeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports